export const calcRowNum = (index, pageInfo, perPage) =>
  pageInfo.total - ((pageInfo.pageNo - 1) * perPage + index);
